import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import * as yup from "yup";

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  ListItem,
  ListItemButton,
  ListItemText,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";

import { toast } from "react-toastify";
import { useFormik } from "formik";
import { API_endspoints } from "../../API/API_endspoints";
import { API_POST } from "../../API/config";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 12,
  p: 4,
  borderRadius: "35px",
  outline: "none",
};

export default function FaqModal({
  id,
  GetFAQ,
  setOpen,
  open,
  modalData,
  setId,
  setModalData,
}) {
  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  const formik = useFormik({
    initialValues: {
      question: "",
      answer: "",
      german_question: "",
      german_answer: "",
      type: null,
    },
    validationSchema: yup.object({
      question: yup.string().required("Required"),
      answer: yup.string().required("Required"),
      german_question: yup.string().required("Required"),
      german_answer: yup.string().required("Required"),
      type: yup.string().required("Required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
     
      const f = new FormData();
      f.append("question", values.question);
      f.append("answer", values.answer);
      f.append("german_question", values.german_question);
      f.append("german_answer", values.german_answer);
      f.append("type", values.type);
      try {
        if (id) {
          f.append("id", id);
          let res = await API_POST(API_endspoints.updatefaq, f);
          if (res?.s) {
            toast.success(res?.m);
            handleClose();
            GetFAQ();
          }
        } else {
          let res = await API_POST(API_endspoints.addfaq, f);
          if (res?.s) {
            toast.success(res?.m);
            handleClose();
            GetFAQ();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  React.useEffect(() => {
    if (modalData) {
      formik.setValues({
        question: modalData?.question,
        answer: modalData?.answer,
        german_question: modalData?.german_question,
        german_answer: modalData?.german_answer,
        type: modalData?.type?.toString(),
      });
    }
  }, [modalData]);

  return (
    <div>
      <Box
        className={"flexCenter"}
        sx={{
          px: 1,
        }}
      >
        <ListItem
          disablePadding
          onClick={() => {
            setId("");
            setModalData({});
            formik.setValues({
              question: "",
              answer: "",
              german_question: "",
              german_answer: "",
              type: null,
              id: "",
            });
            setOpen(true);
          }}
          sx={{
            padding: "0 0.5rem",
            borderRadius: "12px",
            background: "#164FA1",
            color: "#fff",
            "&:hover": {
              background: "#F57C00",
            },
          }}
        >
          <ListItemButton>
            <ListItemText primary={"+ Add FAQ"} />
          </ListItemButton>
        </ListItem>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography sx={{ fontWeight: 600, fontSize: "22px" }}>
            {id ? "Update FAQ" : "Add FAQ"}
          </Typography>
          <Box>
            <TextField
              type="question"
              id="question"
              name="question"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.question}
              error={formik.touched.question && Boolean(formik.errors.question)}
              helperText={formik.touched.question && formik.errors.question}
              variant="outlined"
              fullWidth
              InputProps={{
                sx: {
                  borderRadius: "12px",
                  color: "#000",
                  "&:hover": {
                    color: "#F57C00",
                    bgcolor: "#FFF3E8",
                    borderRadius: "12px",
                  },
                },
              }}
              sx={{
                margin: "0.5rem 0",
                ".MuiInputBase-root": {
                  borderRadius: "11px",
                },
                ".MuiOutlinedInput-input:focus": {
                  outline: "none",
                },
              }}
              placeholder="Enter Question (English)"
            />{" "}
            <TextField
              type="text"
              id="german_question"
              name="german_question"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.german_question}
              error={
                formik.touched.german_question &&
                Boolean(formik.errors.german_question)
              }
              helperText={
                formik.touched.german_question && formik.errors.german_question
              }
              variant="outlined"
              fullWidth
              InputProps={{
                sx: {
                  borderRadius: "12px",
                  color: "#000",
                  "&:hover": {
                    color: "#F57C00",
                    bgcolor: "#FFF3E8",
                    borderRadius: "12px",
                  },
                },
              }}
              sx={{
                margin: "0.5rem 0",
                ".MuiInputBase-root": {
                  borderRadius: "11px",
                },
                ".MuiOutlinedInput-input:focus": {
                  outline: "none",
                },
              }}
              placeholder="Enter Question (German)"
            />{" "}
            <TextField
              type="text"
              id="answer"
              name="answer"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.answer}
              error={formik.touched.answer && Boolean(formik.errors.answer)}
              helperText={formik.touched.answer && formik.errors.answer}
              variant="outlined"
              fullWidth
              InputProps={{
                sx: {
                  borderRadius: "12px",
                  color: "#000",
                  "&:hover": {
                    color: "#F57C00",
                    bgcolor: "#FFF3E8",
                    borderRadius: "12px",
                  },
                },
              }}
              sx={{
                margin: "0.5rem 0",
                ".MuiInputBase-root": {
                  borderRadius: "11px",
                },
                ".MuiOutlinedInput-input:focus": {
                  outline: "none",
                },
              }}
              placeholder="Enter Answer (English)"
            />
            <TextField
              type="text"
              id="german_answer"
              name="german_answer"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.german_answer}
              error={
                formik.touched.german_answer &&
                Boolean(formik.errors.german_answer)
              }
              helperText={
                formik.touched.german_answer && formik.errors.german_answer
              }
              variant="outlined"
              fullWidth
              InputProps={{
                sx: {
                  borderRadius: "12px",
                  color: "#000",
                  "&:hover": {
                    color: "#F57C00",
                    bgcolor: "#FFF3E8",
                    borderRadius: "12px",
                  },
                },
              }}
              sx={{
                margin: "0.5rem 0",
                ".MuiInputBase-root": {
                  borderRadius: "11px",
                },
                ".MuiOutlinedInput-input:focus": {
                  outline: "none",
                },
              }}
              placeholder="Enter Answer (German)"
            />
            <FormControl component="fieldset" sx={{ margin: "0.5rem 0" }}>
              <FormLabel component="legend"> Audience Type</FormLabel>
              <RadioGroup
                id="type"
                name="type"
                value={formik.values.type}
                onChange={formik.handleChange}
                row
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Customer"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Caterer"
                />
              </RadioGroup>
              <Box
                sx={{
                  fontSize: "12px",
                  color: "#d63b3b",
                  display: formik.touched.type ? "block" : "none",
                }}
              >
                {formik.touched.type &&
                  Boolean(formik.errors.type) &&
                  formik.errors.type}
              </Box>
            </FormControl>
          </Box>
          <Box
            className={"flexCenter"}
            sx={{ justifyContent: "space-between", gap: "1rem" }}
          >
            {/* <Button
              variant="outlined"
              sx={{
                width: "100%",
                textTransform: "none",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
              onClick={handleClose}
            >
              Cancle
            </Button> */}
            <Button
              variant="outlined"
              sx={{
                margin: "0.5rem 0",
                width: "100%",
                textTransform: "none",
                borderRadius: "8px",
                backgroundColor: "#164FA1",
                color: "white",
                "&:hover": {
                  backgroundColor: "#164FA1",
                  color: "white",
                },
              }}
              disabled={formik.isSubmitting}
              onClick={formik.handleSubmit}
            >
              {id ? "Update" : "ADD"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
